import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import './styles.scss';
import {Appointment} from "../../../services/dto/Common";
import moment from "moment";
import {FORMAT_HOUR_FULL} from "../../../config";
import {checkIsCanMeeting} from "../../../services/utils";
import { Box, Card, CardHeader, CardContent } from '@mui/material';
import { Paper } from '@mui/material';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';

export interface IGetReadyProps {
  apt: Appointment | any;
}

export const GetReady: React.FunctionComponent<IGetReadyProps> = (props) => {  
  const { apt } = props;
  const history = useHistory();
  const hasStarted = checkIsCanMeeting(apt) && apt.hostJoined;
  const timeLeft = moment(apt.startTime).fromNow()
  const startToEndTime = `${moment(apt.startTime).format(FORMAT_HOUR_FULL)} - ${moment(apt.endTime).format(FORMAT_HOUR_FULL)}`

  const renderWait = () => {
    const timeToStartText = !timeLeft.includes("ago") 
      ? `Starts ${timeLeft}`
      : "The provider will start the meeting shortly";
    return (
      <Card elevation={0} sx={{ padding: '22px 32px', backgroundColor: 'secondary.main' }}>
        <CardHeader sx={{ color: 'secondary.contrastText' }} title={<div style={{ fontWeight: 'bold' }}>{timeToStartText}</div>} />
        <CardContent>
          <Typography variant="body1" color="secondary.contrastText">
            {startToEndTime}
          </Typography>
        </CardContent>
      </Card>
    )
  }

  const renderStartNow = ()=>{
    return (
      <Card elevation={0} sx={{ padding: '22px 32px', backgroundColor: 'secondary.main' }}>
        <CardHeader sx={{ color: 'secondary.contrastText' }} title={<div style={{ fontWeight: 'bold' }}>The specialist has started the meeting</div>} />
        <CardContent>
          <Typography variant="body1" color="secondary.contrastText">
            Enter the waiting room below to join appointment
          </Typography>
          <br />
          <Typography variant="body1" color="secondary.contrastText">
            {startToEndTime}
          </Typography>
        </CardContent>
      </Card>
    )
  }
  return (
    <Paper elevation={0} sx={{ padding: '22px 32px', height: '548px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {/* Header */}
        <Typography variant="h5" fontWeight="bold">Get Ready</Typography>

        {hasStarted ? renderStartNow() : renderWait()}

        {!hasStarted && <Typography variant="body1">Please be ready and in the waiting room at least 5 minutes before your visit.</Typography>}

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => history.push(`/waitingRoomPage?apt=${apt.id}`)}
          sx={{ width: 'fit-content' }}
        >
          Go to Waiting Room
        </Button>
      </Box>
    </Paper>
  );
};

export default GetReady;
